const imgtoData = (img) => {
    var imgData = new Buffer.from(img.data).toString("base64");
    imgData = 'data:' + img.mimetype + ';base64,' + imgData;
    return imgData;
}

export default imgtoData;